import React from "react";
import { Modal, Input, Select, Form, Button, DatePicker } from "antd";
import { SaveOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { FormRules } from "../../../dist/functions/formRules";
import { SelectOptionFooterExtraButtonComponent } from "../../SelectOptionFooterExtraButtonComponent";

const { Option } = Select;
export const RegionsFormModalComponent = (props) => {
  const {
    form = null,
    isVisible,
    onClickSubmit,
    onClickCancel,
    isUpdate,
    island_groups,
    onClickShowMoreIslandGroup,
  } = props;

  const dateFormat = "YYYY-MM-DD hh:mm:ss";

  /**
   * Form Rules
   *
   */

  return (
    <Modal
      title={isUpdate ? "Update Regions" : "Create Regions"}
      visible={isVisible}
      onOk={onClickSubmit}
      onCancel={onClickCancel}
      footer={[
        <Button key="back" onClick={onClickCancel} icon={<ArrowLeftOutlined />}>
          Return
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={onClickSubmit}
          icon={<SaveOutlined />}
        >
          Submit
        </Button>,
      ]}
    >
      <Form form={form} name="regions" layout="vertical">
        <Form.Item
          label="Island Group"
          name="island_group_id"
          fieldKey="island_group_id"
          shouldUpdate={true}
        >
          <Select
            placeholder="Select Island Group"
            virtual={true}
            dropdownRender={(menu) => (
              <SelectOptionFooterExtraButtonComponent
                key="show_more"
                menu={menu}
                onClickShowMoreList={onClickShowMoreIslandGroup}
                isClickShowMoreDisabled={
                  island_groups.data.length < island_groups.total ? false : true
                }
              />
            )}
          >
            {island_groups.data.map((item) => (
              <Option
                id={item.island_group_id}
                key={item.island_group_id}
                value={item.island_group_id}
              >
                {item.island_group_name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="region_name" label="Region Name">
          <Input />
        </Form.Item>

        <Form.Item name="alternative_name" label="Alternative Name">
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};
